import commonSubFlowDefnFactories from 'edge/quoteandbind/common/config/FlowConfig';

export default {
    transition: function transition(flowDefnFactory, lobSpecificSteps, submissionViewModel, $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams, ActionMessageUtil) {

        var fullQuoteFlowDefn = function fullQuoteFlowDefn(step, junction, flow) {
            var commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil);
            var quoteFlow = flow(commonSubFlowDefns.quote);
            var bindFlow = flow(commonSubFlowDefns.bindAndPay);

            var flowDefn = flowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
            var contactDetailsFlow = flow(flowDefn.contactDetails);
            var coverablesFlow = flow(flowDefn.coverables);
            var moreInfoFlow = flow(flowDefn.moreInfo);

            flow(commonSubFlowDefns.globalExits);
            step(contactDetailsFlow.entry, true);
            contactDetailsFlow.exits[lobSpecificSteps.contactDetailsComplete].onNext.goTo(coverablesFlow.entry);
            coverablesFlow.exits[lobSpecificSteps.coverablesComplete].onNext.goTo(quoteFlow.entry);
            quoteFlow.exits[lobSpecificSteps.offeringSelected].onNext.goTo(moreInfoFlow.entry);
            moreInfoFlow.exits[lobSpecificSteps.moreInfoComplete].onNext.goTo(bindFlow.entry);
        };

        var stepToStateMapping = {
            returnHome: function returnHome() {
                return ['zipCode'];
            },
            confirmation: function confirmation(model) {
                return ['qnbconfirmation', {
                    quoteSummary: model.value,
                    returnStateInfo: ['zipCode']
                }];
            },
            error: function error(model, args) {
                return ['contactUs', {
                    quoteID: model.quoteID ? model.quoteID.value : '',
                    errorMsg: args.errorMsg
                }];
            }
        };

        var parentWizardState = 'baseTransactionWizard';
        var flowfactory = wizardFlowService(fullQuoteFlowDefn, parentWizardState, stepToStateMapping);

        flowfactory.start(submissionViewModel, $stateParams);

        return $q.resolve();
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/FullQuoteTransition.js
// module id = 1212
// module chunks = 0